import React from "react";

import slugify from "slugify";

import { translate } from "react-i18next";

import { Facebook, GooglePlus, Twitter, LinkedIn } from "src/icons";

import { Box, Flex, Link, Text } from "src/components/base";

const shareOptions = [
  {
    name: "Facebook",
    Icon: Facebook,
    urlBuilder: ({ url }) =>
      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    size: 16,
  },
  {
    name: "Twitter",
    Icon: Twitter,
    urlBuilder: ({ url, t }) => {
      const message = encodeURIComponent(t("share.twitterPost", { url }));
      return `https://twitter.com/intent/tweet?text=${message}`;
    },
    size: 16,
  },
  {
    name: "LinkedIn",
    Icon: LinkedIn,
    urlBuilder: ({ url, description, t }) => {
      const message = encodeURIComponent(
        t("share.linkedInPost", { url, description })
      );
      return `https://www.linkedin.com/shareArticle?mini=true&url=${url}&summary=${message}`;
    },
    size: 16,
  },
];

const squareSize = 36;

const Share = ({
  t,
  title = t("layout.shareTitle"),
  description,
  url,
  color = "white",
  bg = "blue",
  ...props
}) => (
  <Box {...props}>
    <Text textTransform="uppercase" fontWeight="bold">
      {title}
    </Text>
    <Flex mt={2}>
      {shareOptions.map(({ name, urlBuilder, Icon, size }) => {
        return (
          <Link
            bg={bg}
            key={name}
            height={squareSize}
            width={squareSize}
            align="center"
            justify="center"
            mr={2}
            color={color}
            to={urlBuilder({ url, description, t })}
            textDecoration="none"
            alt={`Share on ${name}`}
            target="_blank"
          >
            <Icon size={size} color={color} />
          </Link>
        );
      })}
    </Flex>
  </Box>
);

export default translate("translations")(Share);



// WEBPACK FOOTER //
// ./src/components/Share/Share.js